<template>
  <span class="x-check-box" :class="{ active: check }" @click="onClick">
    <span class="check-box-icon">
      <el-icon v-if="check" :size="12" color="#fff"><Check /></el-icon>
    </span>
    <span class="check-box-label">{{ label }}</span>
  </span>
</template>

<script lang="ts" setup>
import { computed, ref, reactive } from 'vue'
// 使用计算属性，通过get和set来实现双向绑定
const props = defineProps({
  check: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
})

const onClick = () => {
  emit('update:check', !props.check)
  emit('click')
}


const emit = defineEmits(['click'])
</script>
<style lang="scss">
.x-check-box {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  .check-box-icon {
    display: inline-flex;
    align-items: center;
    width: 14px;
    height: 14px;
    border: 1px solid var(--el-border-color);
    margin-right: 5px;
    border-radius: 2px;
  }
  &.active {
    color: #409eff; //var(--el-checkbox-checked-text-color);
    .check-box-icon {
      background-color: #409eff; //var(--el-checkbox-checked-bg-color);
      border-color: #409eff; //var(--el-checkbox-checked-input-border-color);
    }
  }
}
</style>
